var Popup, Marker; // Classes

var SharplaunchMap = {
    map: null,
    markers: [],
    bounds: null,
    map_center: null,
    active_marker: null,
    active_categories: ['0'],
    cat_colors: {},
    last_zIndex:10000,
    styles: bootstrap.map.styles || null,
    marker_path: 'M7.536,5.064c0,1.398-1.139,2.532-2.544,2.532c-1.405,0-2.544-1.134-2.544-2.532c0-1.398,1.139-2.532,2.544-2.532C6.397,2.532,7.536,3.666,7.536,5.064M10.176,5.064C10.176,2.267,7.897,0,5.088,0C2.278,0,0,2.267,0,5.064c0,1.23,0.441,2.357,1.173,3.234l3.919,5.628l3.976-5.71C9.211,8.039,9.342,7.852,9.46,7.654L9.5,7.597H9.493C9.927,6.852,10.176,5.987,10.176,5.064',
    drawings: [],
    MARKER_WIDTH: 60,
    loadScript: function() {

        var mapsapi = document.createElement("script");
        mapsapi.type = "text/javascript";
        mapsapi.src = "https://maps.google.com/maps/api/js?key=AIzaSyC5z50VGadxviwn6IlNfY0eKT7IUu22ffI&loading=async&libraries=marker&callback=SharplaunchMap.init";
        document.body.appendChild(mapsapi);

    },
    init: function() {

        var self = this;
        let mapCanvas = document.getElementById('map_canvas');
        self.map_center = new google.maps.LatLng(mapCanvas.getAttribute('data-latitude'), mapCanvas.getAttribute('data-longitude'));
        this.bounds = new google.maps.LatLngBounds();
        this.map = new google.maps.Map(document.getElementById('map_canvas'), {
            zoom: parseInt(mapCanvas.dataset.zoom),
            center: self.map_center,
            mapTypeControl: false,
            scrollwheel: false,
            scaleControl: false,
            streetViewControl: false,
            zoomControl: false,
            panControl: false,
            fullscreenControl: false,
            mapTypeId: google.maps.MapTypeId[bootstrap.map.map_type],
            mapId: "1dfc966b10cac119",
        });

        // Map category colors
        bootstrap.poi_cats.forEach((v,k) => {
            self.cat_colors[v.id] = v.color;
        });


        /* ========================================
         * HELPER FUNCTIONS FOR MARKER RENDERING
         * ======================================== */

        function addHoverEffect(element, baseTransform) {
            if (!element) return;
            element.style.transition = 'transform 0.3s ease';
            element.addEventListener('mouseenter', function() {
                this.style.transform = baseTransform + ' scale(1.2)';
                this.style.zIndex = '100';
            });
            element.addEventListener('mouseleave', function() {
                this.style.transform = baseTransform + ' scale(1)';
                this.style.zIndex = '';
            });
        }

        function createExpandedContentHTML(data, categoryColor, hasLogo, logoThumb) {
            return '<div class="expanded-content" style="display: none; background: white; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.15); padding: 16px; min-width: 280px; max-width: 320px; border: 2px solid #' + categoryColor + '; animation: expandIn 0.3s ease-out;">' +
                '<div style="display: flex; align-items: center; margin-bottom: 12px;">' +
                    (hasLogo ? '<div style="width: 40px; height: 40px; border-radius: 8px; display: flex; align-items: center; justify-content: center; margin-right: 12px; flex-shrink: 0; overflow: hidden;"><img src="' + logoThumb + '" style="width: 100%; height: 100%; object-fit: contain; border-radius: 8px;"></div>' : '') +
                    '<div style="flex: 1; min-width: 0;">' +
                        '<div style="font-weight: 600; font-size: 16px; color: #333; margin-bottom: 4px; line-height: 1.2;">' + (data.name || '') + '</div>' +
                    '</div>' +
                '</div>' +
                (data.address ? '<div style="display: flex; align-items: flex-start; font-size: 13px; color: #666; line-height: 1.4; margin-bottom: 12px;">' +
                    '<i class="fa fa-map-marker-alt" style="margin-right: 8px; margin-top: 2px; color: #999; flex-shrink: 0;"></i>' +
                    '<span>' + data.address + '</span>' +
                '</div>' : '') +
            '</div>';
        }

        function createGroupMarkerHTML(data, categoryColor, validItems, count) {
            const styles = data.styles || {};
            // Check if custom width is set via styles.width
            const customWidth = styles.width;
            
            // Build the grid/flex content HTML - always use flexible layout
            let gridHtml = '<div style="width: 100%; height: auto; flex-shrink: 0; overflow: hidden; border-radius: 4px; box-sizing: border-box;">';
            if (count > 0) {
                gridHtml += '<div style="display: flex; flex-wrap: wrap; width: 100%; height: auto; justify-content: center; gap: 4px;">';
                validItems.forEach((item, idx) => {
                    const src = item.logo_thumb_url;
                    const name = item.name || '';
                    // Always use flexible layout for all items
                    if (src) {
                        gridHtml += '<img src="' + src + '" style="max-width: 100px; width: auto; max-height: 50px; object-fit: contain; border-radius: 4px;">';
                    } else {
                        gridHtml += '<div style="height: 50px; padding: 8px 12px; background: #f3f4f6; border-radius: 4px; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 600; color: #374151; max-width: 100px; text-align: center; word-break: break-word;">' + name + '</div>';
                    }
                });
                gridHtml += '</div>';
            } else {
                gridHtml += '<div style="width: 100%; height: 56px; display: flex; align-items: center; justify-content: center; color: #' + categoryColor + '; font-size: 16px; font-weight: bold;">' + (data.name ? data.name.charAt(0) : 'G') + '</div>';
            }
            gridHtml += '</div>';
            
            // For expanded view, use custom width if set, otherwise 320px
            const expandedMaxWidth = customWidth ? customWidth : 320;
            let expandedGridHtml = '';
            if (count > 0) {
                expandedGridHtml = '<div style="display: flex; flex-wrap: wrap; gap: 6px; margin-top: 12px; overflow-y: auto; align-items: center; justify-content: space-evenly;">';
                validItems.forEach(item => {
                    const src = item.logo_thumb_url;
                    const name = item.name || 'Unnamed';
                    if (src) {
                        expandedGridHtml += '<img src="' + src + '" style="max-width: 100px; width: auto; max-height: 50px; object-fit: contain; border-radius: 4px; border: 1px solid #eee;">';
                    } else {
                        expandedGridHtml += '<div style="height: 50px; padding: 8px 12px; background: #f3f4f6; border-radius: 4px; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 600; color: #374151; max-width: 100px; text-align: center; word-break: break-word;">' + name + '</div>';
                    }
                });
                expandedGridHtml += '</div>';
            }
            
            // Collapsed container: use custom width if set, otherwise default to 320px (matching CMS editor default)
            const collapsedWidthStyle = 'width: ' + (customWidth || 320) + 'px;';
            return '<div class="group-marker collapsed-marker" style="display: inline-flex; flex-direction: row; align-items: center; justify-content: center; flex-wrap: wrap; gap: 6px; ' + collapsedWidthStyle + ' background-color: white; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.3); cursor: pointer; padding: 6px; box-sizing: border-box; transition: all 0.3s ease;">' + gridHtml + '</div>' +
            '<div class="expanded-content" style="display: none; background: white; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.15); padding: 16px; min-width: 280px; max-width: ' + expandedMaxWidth + 'px; border: 2px solid #' + categoryColor + '; animation: expandIn 0.3s ease-out;"><div style="text-align: center; margin-bottom: 12px;"><div><div style="font-weight: 600; font-size: 16px; color: #333; margin-bottom: 4px; line-height: 1.2;">' + (data.name || 'Group') + '</div>' + (count > 0 ? '<div style="font-size: 11px; color: #666; font-weight: 500;">' + count + ' item' + (count !== 1 ? 's' : '') + '</div>' : '') + '</div></div>' + expandedGridHtml + '</div>';
        }

        function createBuildingMarkerHTML(data, categoryColor, hasLogo, shouldShowName, logoThumb, displayText) {
            const markerSize = 105;
            const borderWidth = 4;
            let innerContent = '';
            if (hasLogo && shouldShowName) {
                innerContent = '<img src="' + logoThumb + '" style="width: 100%; height: auto; max-height: 60%; object-fit: contain; margin-bottom: 4px;"><span>' + displayText + '</span>';
            } else if (hasLogo) {
                innerContent = '<img src="' + logoThumb + '" style="width: 100%; height: 100%; object-fit: contain;">';
            } else if (shouldShowName) {
                innerContent = '<span>' + displayText + '</span>';
            }
            return '<div style="position: relative; display: inline-block; z-index: 1000;"><div class="building-marker collapsed-marker" style="position: relative; background-color: white; border: ' + borderWidth + 'px solid #' + categoryColor + '; border-radius: 8px; width: ' + markerSize + 'px; height: ' + markerSize + 'px; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #000000; font-size: 13px; font-weight: 600; text-align: center; padding: 8px; word-wrap: break-word; box-shadow: 0 2px 6px rgba(0,0,0,0.3); box-sizing: border-box; overflow: visible; cursor: pointer; transition: all 0.3s ease; transform: translateY(-9px);">' + innerContent + '<div style="position: absolute; bottom: -14px; left: 50%; transform: translateX(-50%); width: 0; height: 0; border-left: 14px solid transparent; border-right: 14px solid transparent; border-top: 14px solid #' + categoryColor + ';"></div><div style="position: absolute; bottom: -8px; left: 50%; transform: translateX(-50%); width: 0; height: 0; border-left: 10px solid transparent; border-right: 10px solid transparent; border-top: 10px solid white;"></div></div>' + createExpandedContentHTML(data, categoryColor, hasLogo, logoThumb) + '</div>';
        }

        function createDotMarkerHTML(data, categoryColor, hasLogo, logoThumb) {
            return '<div class="dot-marker collapsed-marker" style="background-color: #' + categoryColor + '; width: 20px; height: 20px; border-radius: 50%; border: 2px solid white; box-shadow: 0 1px 3px rgba(0,0,0,0.3); cursor: pointer; transition: all 0.3s ease;"></div>' + createExpandedContentHTML(data, categoryColor, hasLogo, logoThumb);
        }

        function createLogoMarkerHTML(data, categoryColor, hasLogo, shouldShowName, shouldShowLogo, logoThumb, borderStyle) {
            return '<div class="logo-marker collapsed-marker" style="display: flex; align-items: center; justify-content: center; flex-direction: column; background-color: white; color: #000000; max-width: 200px; border-radius: 6px; padding: 6px; font-size: 10px; font-weight: 600; text-align: center; word-wrap: break-word; box-shadow: 0 2px 6px rgba(0,0,0,0.3); transition: all 0.3s ease; position: absolute; transform: translate(-50%, -50%); ' + borderStyle + '">' + (shouldShowLogo && hasLogo ? '<img src="' + logoThumb + '" class="marker-logo" style="width: auto; height: 36px; border-radius: 6px; object-fit: cover; margin-bottom: ' + (shouldShowName ? '4px' : '0') + ';">' : '') + (shouldShowName ? '<span style="font-size: 10px; font-weight: 600; text-align: center; color: #000;">' + data.name + '</span>' : '') + '</div>' + createExpandedContentHTML(data, categoryColor, hasLogo, logoThumb);
        }

        /* Popup Class - Now using AdvancedMarkerElement like Marker */
        Popup = function(index, data, position, content) {
            var that = this;
            this.index = index;
            this.visible = true;
            // Use position if provided (LatLng object), otherwise create from data
            if (data.offset_lat != null && data.offset_lng != null) {
                this.position = new google.maps.LatLng(data.offset_lat, data.offset_lng);
            } else if (data.offset_location) {
                this.position = new google.maps.LatLng(data.offset_location.lat, data.offset_location.lng);
            } else {
                this.position = position || new google.maps.LatLng(data.lat, data.lng);
            }
            this.map = SharplaunchMap.map;
            // Set higher zIndex for building markers to ensure they appear on top
            const isBuildingMarker = data.base_style === 'building';
            this.zIndex = isBuildingMarker ? 99999 : 9999;
            this.originalZIndex = this.zIndex; // Store original zIndex for restoration
            this.poi = data;
            this.type = 'logo';
            this.isExpanded = false;

            // Check if marker has meaningful data (name, address, or category)
            let hasMeaningfulData = !!(data.name || data.address || data.category !== undefined);
            
            // Build marker content using the same approach as Marker
            const markerContent = this.buildMarkerContent(data, content);
            this.content = markerContent;
            
            const advancedMarkerOptions = {
                map: this.map,
                position: this.position,
                zIndex: this.zIndex,
            };

            if (this.poi.name) advancedMarkerOptions.title = this.poi.name;
            // Always set content if we have meaningful data
            if (hasMeaningfulData) {
                advancedMarkerOptions.content = markerContent;
            }
            
            this.marker = new google.maps.marker.AdvancedMarkerElement(advancedMarkerOptions);
            
            // Create an OverlayView (same as Marker)
            this.overlay = new google.maps.OverlayView();
            this.overlay.onAdd = function() {};
            this.overlay.draw = function() {};
            this.overlay.setMap(this.map);
            
            // Attach click and hover listeners if marker has meaningful data
            if (hasMeaningfulData) {
                // Click listener for expand/collapse
                this.marker.addListener('click', function(e) {
                    e.stop();
                    that.toggleExpand();
                });
                
                // Hover listener for visual feedback
                this.marker.addListener('mouseover', function(e) {
                    e.stop();
                    // Query the content element we created
                    var collapsedMarker = that.content.querySelector('.collapsed-marker');
                    if (collapsedMarker) {
                        collapsedMarker.style.transform = 'translate(-50%, -50%) scale(1.1)';
                        collapsedMarker.style.transition = 'transform 0.2s ease';
                    }
                });
                
                this.marker.addListener('mouseout', function(e) {
                    e.stop();
                    var collapsedMarker = that.content.querySelector('.collapsed-marker');
                    if (collapsedMarker) {
                        collapsedMarker.style.transform = 'translate(-50%, -50%) scale(1)';
                    }
                });
            }
            
            
            // Create Leg/Callout if offset exists
            if (data.offset_lat != null || data.offset_location) {
                var origin = new google.maps.LatLng(data.lat, data.lng);
                var destination = this.position;
                
                var lineSymbol = {
                    path: 'M 0,-1 0,1',
                    strokeOpacity: 1,
                    scale: 4
                };

                var calloutStyles = data.callout_styles || { color: '#000000', weight: 2, opacity: 1 };
                
                this.leg = new google.maps.Polyline({
                    path: [origin, destination],
                    geodesic: false,
                    strokeColor: calloutStyles.color,
                    strokeOpacity: calloutStyles.opacity,
                    strokeWeight: calloutStyles.weight,
                    map: this.map,
                    zIndex: this.zIndex - 1
                });
            }

            SharplaunchMap.bounds.extend(this.position);
        };

        Popup.prototype.buildMarkerContent = function(data, originalContent) {
            const content = originalContent || document.createElement('div');
            const categoryColor = data.category && SharplaunchMap.cat_colors[data.category] ? SharplaunchMap.cat_colors[data.category] : '0071e2';
            const logoThumb = data.logo_thumb_url || data.logo_url;
            const hasLogo = logoThumb && logoThumb.trim() !== '';
            const shouldShowLogo = data.show_logo !== false;
            const shouldShowName = data.show_name !== false;
            const isGroupMarker = data.base_style === 'group' || (data.merged_markers && data.merged_markers.length > 0) || (data.images && data.images.length > 0);
            const isBuildingMarker = data.base_style === 'building';

            if (isGroupMarker) {
                let groupItems = data.merged_markers || [];
                if ((!groupItems || groupItems.length === 0) && data.images) {
                    groupItems = data.images.map(img => ({logo_thumb_url: img.thumb_url || img.url, name: img.caption || img.name}));
                }
                const validItems = groupItems.filter(item => item && (item.logo_thumb_url || item.name));
                const count = validItems.length;
                content.innerHTML = createGroupMarkerHTML(data, categoryColor, validItems, count);
                addHoverEffect(content.querySelector('.group-marker'), '');
            } else if (isBuildingMarker) {
                const displayText = data.name || data.address || 'Building';
                content.innerHTML = createBuildingMarkerHTML(data, categoryColor, hasLogo, shouldShowName, logoThumb, displayText);
                addHoverEffect(content.querySelector('.building-marker'), 'translateY(-9px)');
            } else if (!shouldShowLogo && !shouldShowName) {
                content.innerHTML = createDotMarkerHTML(data, categoryColor, hasLogo, logoThumb);
                addHoverEffect(content.querySelector('.dot-marker'), '');
            } else {
                let borderStyle = '';
                if (data.category && data.category !== "0" && data.category !== "") {
                    borderStyle = 'border-bottom: 3px solid #' + categoryColor + '; ';
                }
                content.innerHTML = createLogoMarkerHTML(data, categoryColor, hasLogo, shouldShowName, shouldShowLogo, logoThumb, borderStyle);
                addHoverEffect(content.querySelector('.logo-marker'), 'translate(-50%, -50%)');
            }
            return content;
        };
        Popup.prototype.toggleExpand = function() {
            var self = this;
            var collapsedMarker = this.content.querySelector('.collapsed-marker');
            var expandedContent = this.content.querySelector('.expanded-content');
            
            if (!collapsedMarker || !expandedContent) {
                // No expand/collapse structure, do nothing
                return;
            }
            
            if (this.isExpanded) {
                // Collapse
                collapsedMarker.style.display = '';
                expandedContent.style.display = 'none';
                this.content.classList.remove('expanded', 'highlight');
                this.content.classList.add('collapsed');
                this.marker.zIndex = this.originalZIndex; // Restore original zIndex
                this.isExpanded = false;
            } else {
                // Collapse all other markers first
                SharplaunchMap.closeAllExpandedMarkers();
                SharplaunchMap.closeAllExpandedPopups();
                
                // Expand this marker
                collapsedMarker.style.display = 'none';
                expandedContent.style.display = 'block';
                this.content.classList.remove('collapsed');
                this.content.classList.add('expanded', 'highlight');
                // Set very high zIndex for expanded popup to stay on top of everything
                this.marker.zIndex = 999999;
                this.isExpanded = true;
            }
        };

        Popup.prototype.isVisible =  function(){ return this.visible; }

        Popup.prototype.getPosition =  function(){ return this.position; }

        Popup.prototype.hideTooltip = function(){
            this.content.classList.add("shadow");
            let mapTooltip = document.getElementById('map-tooltip');
            mapTooltip.classList.remove("regular", "logo");
            mapTooltip.classList.add("hide");
        }

        Popup.prototype.showTooltip = function() {
            if (this.poi.category === "" && this.poi.name === "") return;
            
            var that = this;
            self.closeAllTooltips();
            self.active_marker = this.index;
            this.hide();
            self.last_zIndex++;
            this.anchor.style.zIndex = self.last_zIndex;

            var html = '<div class="tooltip-content"><h3>'+this.poi.name+'</h3><span>'+this.poi.address+'</span></div>';
            
            var logo_html = "";
            if (this.poi.logo_url) {
                logo_html = '<img width="100" src="'+this.poi.logo_url+'">';
            }

            html = '<i class="icon close icon-close" style="display:none;cursor:pointer;position:absolute;right:4px;top:3px;color:#ddd;"></i>'
                    + logo_html 
                    + html;

            this.tooltipPosition();

            var mapTooltip = document.querySelector('#map-tooltip');
            mapTooltip.classList.remove('regular');
            mapTooltip.classList.add('logo');
            mapTooltip.innerHTML = html;
            mapTooltip.style.width = '73px';
            mapTooltip.style.height = '73px';
            mapTooltip.classList.remove('hide');
            mapTooltip.style.padding = '0';
            mapTooltip.style.maxHeight = '0';
            mapTooltip.style.overflow = 'hidden';

            var closeIcon = mapTooltip.querySelector('.icon-close');
            closeIcon.style.display = 'none';

            var animation = mapTooltip.animate([
                {width: '73px', height: '73px', padding: '10px'},
                {width: '335px', height: 'inherit', padding: '10px'}
            ], { duration: 250 });

            animation.onfinish = function() {
                closeIcon.style.display = 'block';
                mapTooltip.style.width = '335px';
                mapTooltip.style.padding = '10px';
                closeIcon.addEventListener('click', function() {
                self.closeAllTooltips();
                });
            };
        };

        Popup.prototype.tooltipPosition = function(){
            var overlay = this.overlay;
            var proj = overlay.getProjection();
            var pos = proj.fromLatLngToContainerPixel(this.getPosition());
            var left = pos.x - 20;
            var top = pos.y + 22;
            // set position
            var tooltip = document.getElementById('map-tooltip');
            tooltip.style.left = left + 'px';
            tooltip.style.top = top + 'px';
            tooltip.style.display = "block";
        }

        Popup.prototype.show = function(){
            this.marker.setMap(SharplaunchMap.map);
            if (this.leg) this.leg.setMap(SharplaunchMap.map);
            this.visible = true;
        }

        Popup.prototype.hide = function(){
            this.marker.setMap(null);
            if (this.leg) this.leg.setMap(null);
            this.visible = false;
            this.hideTooltip();
        }

        /* Marker Class */
        Marker = function(index, data) {
            var that = this;
            this.index = index;
            this.visible = true;
            this.visible = true;
            if (data.offset_lat != null && data.offset_lng != null) {
                this.position = new google.maps.LatLng(data.offset_lat, data.offset_lng);
            } else if (data.offset_location) {
                this.position = new google.maps.LatLng(data.offset_location.lat, data.offset_location.lng);
            } else {
                this.position = new google.maps.LatLng(data.lat, data.lng);
            }
            this.map = SharplaunchMap.map;
            // Set higher zIndex for building markers to ensure they appear on top
            const isBuildingMarker = data.base_style === 'building';
            this.zIndex = isBuildingMarker ? 99999 : 9999;
            this.originalZIndex = this.zIndex; // Store original zIndex for restoration
            this.poi = data;
            this.isExpanded = false;

            // Check if marker has meaningful data (name, address, or category)
            // This is more reliable than counting keys, as old markers might have minimal properties
            // Handle both undefined and empty string for category
            let hasMeaningfulData = !!(data.name || data.address || (data.category !== undefined && data.category !== null && data.category !== ''));
            
            // Build marker content matching Vue component styles
            const markerContent = this.buildMarkerContent(data);
            this.content = markerContent;
            
            const advancedMarkerOptions = {
                map: this.map,
                position: this.position,
                zIndex: this.zIndex,
            };

            if (this.poi.name) advancedMarkerOptions.title = this.poi.name;
            // Always set content if we have meaningful data
            if (hasMeaningfulData) {
                advancedMarkerOptions.content = markerContent;
            }
            
            this.marker = new google.maps.marker.AdvancedMarkerElement(advancedMarkerOptions);
            
            // Create an OverlayView
            this.overlay = new google.maps.OverlayView();
            this.overlay.onAdd = function() {};
            this.overlay.draw = function() {};
            this.overlay.setMap(this.map);
            
            // Attach click and hover listeners if marker has meaningful data
            if (hasMeaningfulData) {
                // Click listener for expand/collapse
                this.marker.addListener('click', function(e) {
                    e.stop();
                    that.toggleExpand();
                });
                
                // Hover listener for visual feedback
                this.marker.addListener('mouseover', function(e) {
                    e.stop();
                    // Query the content element we created
                    var collapsedMarker = that.content.querySelector('.collapsed-marker');
                    if (collapsedMarker) {
                        collapsedMarker.style.transform = 'translate(-50%, -50%) scale(1.1)';
                        collapsedMarker.style.transition = 'transform 0.2s ease';
                    }
                });
                
                this.marker.addListener('mouseout', function(e) {
                    e.stop();
                    var collapsedMarker = that.content.querySelector('.collapsed-marker');
                    if (collapsedMarker) {
                        collapsedMarker.style.transform = 'translate(-50%, -50%) scale(1)';
                    }
                });
            }
            
            
            // Create Leg/Callout if offset exists
            if (data.offset_lat != null || data.offset_location) {
                var origin = new google.maps.LatLng(data.lat, data.lng);
                var destination = this.position;
                
                var calloutStyles = data.callout_styles || { color: '#000000', weight: 2, opacity: 1 };
                
                this.leg = new google.maps.Polyline({
                    path: [origin, destination],
                    geodesic: false,
                    strokeColor: calloutStyles.color,
                    strokeOpacity: calloutStyles.opacity,
                    strokeWeight: calloutStyles.weight,
                    map: this.map,
                    zIndex: this.zIndex - 1
                });
            }

            SharplaunchMap.bounds.extend(this.position);
        };

        Marker.prototype.buildMarkerContent = function(data) {
            const content = document.createElement('div');
            const categoryColor = data.category && SharplaunchMap.cat_colors[data.category] ? SharplaunchMap.cat_colors[data.category] : '0071e2';
            const logoThumb = data.logo_thumb_url || data.logo_url;
            const hasLogo = logoThumb && logoThumb.trim() !== '';
            const shouldShowLogo = data.show_logo !== false;
            const shouldShowName = data.show_name !== false;
            const isGroupMarker = data.base_style === 'group' || (data.merged_markers && data.merged_markers.length > 0) || (data.images && data.images.length > 0);
            const isBuildingMarker = data.base_style === 'building';

            if (isGroupMarker) {
                let groupItems = data.merged_markers || [];
                if ((!groupItems || groupItems.length === 0) && data.images) {
                    groupItems = data.images.map(img => ({logo_thumb_url: img.thumb_url || img.url, name: img.caption || img.name}));
                }
                const validItems = groupItems.filter(item => item && (item.logo_thumb_url || item.name));
                const count = validItems.length;
                content.innerHTML = createGroupMarkerHTML(data, categoryColor, validItems, count);
                addHoverEffect(content.querySelector('.group-marker'), '');
            } else if (isBuildingMarker) {
                const displayText = data.name || data.address || 'Building';
                content.innerHTML = createBuildingMarkerHTML(data, categoryColor, hasLogo, shouldShowName, logoThumb, displayText);
                addHoverEffect(content.querySelector('.building-marker'), 'translateY(-9px)');
            } else if (!shouldShowLogo && !shouldShowName) {
                content.innerHTML = createDotMarkerHTML(data, categoryColor, hasLogo, logoThumb);
                addHoverEffect(content.querySelector('.dot-marker'), '');
            } else {
                let borderStyle = '';
                if (data.category && data.category !== "0" && data.category !== "") {
                    borderStyle = 'border-bottom: 3px solid #' + categoryColor + '; ';
                }
                content.innerHTML = createLogoMarkerHTML(data, categoryColor, hasLogo, shouldShowName, shouldShowLogo, logoThumb, borderStyle);
                addHoverEffect(content.querySelector('.logo-marker'), 'translate(-50%, -50%)');
            }
            return content;
        };
        Marker.prototype.toggleExpand = function() {
            var self = this;
            var collapsedMarker = this.content.querySelector('.collapsed-marker');
            var expandedContent = this.content.querySelector('.expanded-content');
            
            if (!collapsedMarker || !expandedContent) {
                // No expand/collapse structure, do nothing
                return;
            }
            
            if (this.isExpanded) {
                // Collapse
                collapsedMarker.style.display = '';
                expandedContent.style.display = 'none';
                this.content.classList.remove('expanded', 'highlight');
                this.content.classList.add('collapsed');
                this.marker.zIndex = this.originalZIndex; // Restore original zIndex
                this.isExpanded = false;
            } else {
                // Collapse all other markers first
                SharplaunchMap.closeAllExpandedMarkers();
                
                // Expand this marker
                collapsedMarker.style.display = 'none';
                expandedContent.style.display = 'block';
                this.content.classList.remove('collapsed');
                this.content.classList.add('expanded', 'highlight');
                // Set very high zIndex for expanded marker to stay on top of everything
                this.marker.zIndex = 999999;
                this.isExpanded = true;
            }
        };

        Marker.prototype.isVisible =  function(){ return this.visible; }

        Marker.prototype.showTooltip = function(){
            SharplaunchMap.closeAllTooltips();
            SharplaunchMap.active_marker = this.index;
            if (this.poi.name || this.poi.address) {
                var html = '<i class="icon close icon-close" style="cursor:pointer;position:absolute;right: 4px;    top: 3px;    color: #ddd;"></i><div class="tooltip-content"><h3>'+this.poi.name+'</h3><span>'+this.poi.address+'</span></div>';
                var mapTooltip = document.querySelector('#map-tooltip');
                mapTooltip.classList.remove('logo');
                mapTooltip.classList.add('regular');
                mapTooltip.innerHTML = html;
                mapTooltip.classList.remove('hide');
                if (this.poi.category == "0" || this.poi.category == "") {
                    mapTooltip.classList.add('building');
                }
                var overlay = this.overlay;
                var proj = overlay.getProjection();
                var pos = proj.fromLatLngToContainerPixel(this.getPosition());
                var left = pos.x - 20;
                var top = pos.y + 22;
                mapTooltip.style.left = left + 'px';
                mapTooltip.style.top = top + 'px';
                var iconClose = mapTooltip.querySelector('.icon-close');
                iconClose.addEventListener('click', function() {
                    SharplaunchMap.closeAllTooltips();
                });
            }            
        }
        Marker.prototype.tooltipPosition = function(){
            var overlay = this.overlay;
            var proj = overlay.getProjection();
            var pos = proj.fromLatLngToContainerPixel(this.getPosition());
            var left = pos.x - 20;
            var top = pos.y + 22;

            var mapTooltip = document.querySelector('#map-tooltip');
            mapTooltip.style.left = left + 'px';
            mapTooltip.style.top = top + 'px';
        }
        Marker.prototype.show = function(){
            this.marker.setMap(SharplaunchMap.map);
            if (this.leg) this.leg.setMap(SharplaunchMap.map);
            this.visible = true;
        }

        Marker.prototype.hide = function(){
            this.marker.setMap(null);
            if (this.leg) this.leg.setMap(null);
            this.visible = false;
            this.hideTooltip();
        }

        Marker.prototype.hideTooltip = function(){
            var mapTooltip = document.querySelector('#map-tooltip');
            mapTooltip.classList.remove('regular');
            mapTooltip.classList.remove('logo');
            mapTooltip.classList.add('hide');
        };

        Marker.prototype.getPosition = function() {
            return this.position;
        }

        /****************** END classes definitions ************************/


        // var main_marker = null;
        var main_markers = [];
        if (bootstrap.poi.length) {
            bootstrap.poi.forEach(function(v,k) {
                // Handle text markers first (they should go through placeMarker which routes to placeTextMarker)
                if (v.is_text_label || v.base_style === 'text') {
                    self.placeMarker(v);
                } else if (v.category == "0" || v.category == "") {
                    main_markers.push(v);
                    // main_marker = v;
                    // self.placeMainMarker(v);
                } else {
                    self.placeMarker(v);
                }
            });

        } else {
            self.placeMarker({
                lat: parseFloat(document.querySelector('#map_canvas').getAttribute('data-latitude')),
                lng: parseFloat(document.querySelector('#map_canvas').getAttribute('data-longitude'))
            });
        }
        
        // Render Building marker last, so it's on Z top
        // if (main_marker) self.placeMainMarker(main_marker);
        if (main_markers.length) {
            main_markers.forEach(function(building_marker,k) {
                self.placeMainMarker(building_marker);
            });
        } 

        if (bootstrap.poi_cats.length) {
            bootstrap.poi_cats.forEach(function(v,k) {
                if (v.id != '0') {
                    self.active_categories.push(v.id);
                }
            });
        }

        // Render drawings (polygons)
        if (bootstrap.drawings && bootstrap.drawings.length) {
            self.renderDrawings();
        }

        google.maps.event.addListener(this.map,'click',function(e) {
            self.closeAllTooltips();
            self.closeAllExpandedMarkers();
            self.closeAllExpandedPopups();
        });

        google.maps.event.addListener(this.map,'zoom_changed',function() {
           self.closeAllTooltips();
        });

        google.maps.event.addListener(this.map,'center_changed',function() {
           // self.closeAllTooltips();
                self.tooltipPosition();
        });

        // enable controls
        this.mapControls();
    },
    tooltipPosition: function (){
        var self = this;
        if (self.active_marker != null){
            self.markers[self.active_marker].tooltipPosition();
        }
    },
    placeMarker: function(data) {
        var self = this;
        var location = new google.maps.LatLng(data.lat, data.lng);
        var index = self.markers.length;

        // Handle text markers
        if (data.is_text_label || data.base_style === 'text') {
            self.placeTextMarker(data, location, index);
            return;
        }


        // Always use the new Marker/Popup classes with buildMarkerContent
        if (data.logo_url && data.logo_url !== "" && bootstrap.map.show_logos_directly && data.category !== "0") {
            let popup = new Popup(index, data, location);
            this.markers.push(popup);
        } else {
            let marker = new Marker(index, data);
            this.markers.push(marker);
        }


    },
    // Merge this back to placeMarker with an IF statement
    placeMainMarker: function(data) {
        var self = this;
        var location = new google.maps.LatLng(data.lat,data.lng)
        var index = self.markers.length;

        data.is_property = true;

        var marker_content = data.name;

        // lower fontsize if text is too long and/or cut it
        if (marker_content.length > 23){
            marker_content = '<span style="font-size:12px">' + marker_content.substr(0, 35) + '</span>';
        }

        if (data.logo_url){
            marker_content = '<img width="50" src="'+data.logo_url+'">';
        }

        var html  = '<div id="randombubblemarker-'+index+'" class="shadow marker-bubble is-property">' + marker_content + '</div>';

        // Change marker for MM 123
        if (window.bootstrap.client_id == 123) {
            html = '<div id="randombubblemarker-' + index + '" class="is-svg-custom"><img width="40" height="50" src="/img/v2/clients/mm/map-marker.svg"></div>';
        }

        document.querySelector('body').insertAdjacentHTML('beforeend', html);
        popup = new Popup(index, data,
        location,
        document.getElementById('randombubblemarker-'+index));
        this.markers.push(popup);

    },
    filterPoisByCategory: function() {
        var self = this;

        for (var i = 0; i < this.markers.length; i++) {
            var marker = this.markers[i];
            var poi = marker.poi;
            
            // Text markers should always be visible (they don't have categories to filter)
            if (poi.is_text_label || poi.base_style === 'text') {
                if (!marker.isVisible()) {
                    marker.show();
                }
                continue;
            }
            
            // Skip filtering for POIs without a category - they should always stay visible
            var hasNoCategory = poi.category === "" || poi.category === "0" || poi.category === 0 || poi.category === null || poi.category === undefined;
            if (hasNoCategory) {
                // POIs without categories should always be visible
                if (!marker.isVisible()) {
                    marker.show();
                }
                continue;
            }
            
            // Check if the POI's category is in the known categories list (poi_cats)
            // If not, the POI should always stay visible (it's not filterable)
            var knownCategoryIds = bootstrap.poi_cats.map(function(cat) { return cat.id; });
            var categoryInLegend = knownCategoryIds.indexOf(poi.category) > -1;
            if (!categoryInLegend) {
                // POI has a category but it's not in the legend, keep it visible
                if (!marker.isVisible()) {
                    marker.show();
                }
                continue;
            }
            
            // Only filter POIs that have a valid category in the legend
            if (self.active_categories.indexOf(poi.category) === -1) {
                if (marker.isVisible()) {
                    marker.hide();
                }
            } else if (!marker.isVisible()) {
                marker.show();
            }
          }
    },
    closeAllTooltips: function(){
        let self = this;
        self.active_marker = null;
        let markerBubbles = document.querySelectorAll('.marker-bubble');
        markerBubbles.forEach(function(markerBubble) {
            markerBubble.classList.add('shadow');
        });
        for (let i = 0; i < this.markers.length; i++ ) {
            if (!this.markers[i].isVisible() && (self.active_categories.indexOf(this.markers[i].poi.category) > -1 || this.markers[i].poi.category == "") )
            this.markers[i].show();
        }
        let mapTooltip = document.querySelector('#map-tooltip');
        mapTooltip.classList.remove('building', 'regular', 'logo');
        mapTooltip.classList.add('hide');

    },
    closeAllExpandedMarkers: function(){
        var self = this;
        for (var i = 0; i < this.markers.length; i++) {
            var marker = this.markers[i];
            if (marker && marker.isExpanded && marker.toggleExpand) {
                marker.toggleExpand();
            }
        }
    },
    closeAllExpandedPopups: function(){
        var self = this;
        for (var i = 0; i < this.markers.length; i++) {
            var marker = this.markers[i];
            // Check if it's a Popup instance with expand functionality
            if (marker && marker.type === 'logo' && marker.isExpanded && marker.toggleExpand) {
                marker.toggleExpand();
            }
        }
    },
    mapControls: function() {
        var self = this;

        // self.map.fitBounds(self.bounds);

        let mapCategories = document.querySelectorAll('#map-categories li');
        mapCategories.forEach(function(category) {
            category.addEventListener('click', function(e) {
                if (!category.classList.contains('active')) {
                    category.classList.add('active');
                    // add to active categories
                    self.active_categories.push(category.dataset.id);
                } else {
                    category.classList.remove('active');

                    // get index of class to be removed
                    let index = self.active_categories.indexOf(category.dataset.id);
                    if (index > -1) {
                        self.active_categories.splice(index, 1);
                    }
                }
                self.filterPoisByCategory();
            });
        });

        // init zoom control
        // if($('#zoom-slider').length) {
        //     var zoom_slider = $('#zoom-slider').slider({
        //         min: 10,
        //         max: 20,
        //         step: 1,
        //         range: 'min',
        //         value: $('#map_canvas').data('zoom'),
        //         slide: function(event, ui) {
        //             self.map.setZoom(ui.value);
        //         }
        //     });
        // }

        var zoomInButton = document.querySelector('.zoom-control .zoom-in');
        if (zoomInButton) zoomInButton.addEventListener('click', function(){
            var value;
            if(typeof zoom_slider !== 'undefined') {
                value = document.querySelector('#zoom-slider').slider('value') + 1;
                // $('#zoom-slider').slider('value', value);
            } else {
                value = self.map.getZoom() + 1;
            }
            self.map.setZoom(value);
        });

        var zoomOutButton = document.querySelector('.zoom-control .zoom-out');
        if (zoomOutButton) zoomOutButton.addEventListener('click', function(){
            var value;
            if(typeof zoom_slider !== 'undefined') {
                value = document.querySelector('#zoom-slider').slider('value') - 1;
                // $('#zoom-slider').slider('value', value);
            } else {
                value = self.map.getZoom() - 1;
            }
            self.map.setZoom(value);
        });

        var mapTypeButton = document.querySelector('.map-type');
        if (mapTypeButton) mapTypeButton.addEventListener('click', function(){
            if (this.classList.contains("open")) {
                this.classList.remove("open");
            } else {
                this.classList.add("open");
            }
        });

        var mapTypeList = document.querySelectorAll('.map-type ul li');
        if (mapTypeList) {
            mapTypeList.forEach(function(item) {
                item.addEventListener('click', function(e) {
                    e.preventDefault();
                    var type = this.querySelector('a').getAttribute('map-type');
                    switch (type) {
                        case 'terrain':
                            type = google.maps.MapTypeId.TERRAIN;
                            break;
                        case 'default':
                            type = google.maps.MapTypeId.ROADMAP;
                            break;
                        case 'hybrid':
                            type = google.maps.MapTypeId.HYBRID;
                            break;
                    }
                    self.map.setMapTypeId(type);
                });
            });
        }        

        var enterFullScreenButton = document.getElementById("enter-full-screen");
        if (enterFullScreenButton) enterFullScreenButton.addEventListener("click", function (e) {
            e.preventDefault();
            if (document.body.classList.contains("map-full-screen")) {
                self.closeFullScreen();
                var zoomButtons = document.querySelectorAll(
                    ".zoom-control .button"
                );
                for (var i = 0; i < zoomButtons.length; i++) {
                    zoomButtons[i].classList.remove("active");
                }
            } else {
                document
                    .querySelector(".zoom-control #enter-full-screen")
                    .classList.add("active");
                self.openFullScreen();
            }
        });

        var exitFullScreenButton = document.getElementById("exit-full-screen");
        if (exitFullScreenButton) exitFullScreenButton.addEventListener("click", function (e) {
            e.preventDefault();
            self.closeFullScreen();
        });  

        var centerInButton = document.querySelector(".zoom-control .center-in");
        if (centerInButton) centerInButton.addEventListener("click", function () {
            self.map.setCenter(map_center);
            self.map.setZoom(12);
            document.querySelector("#zoom-slider").slider("value", 15);
        });

        var legendButton = document.querySelector(".zoom-control .button.legend");
        if (legendButton) legendButton.addEventListener("click", function () {
            if (!this.classList.contains("active")) {
                this.textContent = "Hide Legend";
                this.classList.add("active");
                document
                    .querySelector("#map-categories")
                    .classList.add("active");
            } else {
                this.textContent = "View Legend";
                this.classList.remove("active");
                document
                    .querySelector("#map-categories")
                    .classList.remove("active");
            }
        });

        // set position
        /*
        $('.zoom-control').css({
            top: $('#location .section-title').position().top+$('#location .section-title').outerHeight()
        });
        */
       var locationTitle = document.querySelector('#location .section-title');
       if (locationTitle) this.map.panBy(0, -Math.floor(locationTitle.offsetHeight / 2));

    },
    openFullScreen: function(){
        document.querySelector("#map_canvas").classList.add("fullscreen");
        document.querySelector('body').classList.add("map-full-screen");
        document.querySelector('#map-tooltip').style.position = "fixed";
        setTimeout(function(){
        google.maps.event.trigger(self.map, 'resize');
        },500);

        return false;
    },
    closeFullScreen: function(){
        document.querySelector('body').classList.remove('map-full-screen');
        document.querySelector('#map_canvas').classList.remove('fullscreen');
        document.querySelector('#map-tooltip').style.position = 'absolute';

        return false;
    },
    placeTextMarker: function(data, location, index) {
        var self = this;
        
        // Determine final marker position (destination) checking for offsets
        var destination = location;
        if (data.offset_lat != null && data.offset_lng != null) {
            destination = new google.maps.LatLng(data.offset_lat, data.offset_lng);
        } else if (data.offset_location) {
            destination = new google.maps.LatLng(data.offset_location.lat, data.offset_location.lng);
        }
        
        // Create text label element - matching Vue component styles
        const textContent = data.content || data.name || '';
        
        // Get styles from data.styles object (nested) or fall back to direct properties
        const styles = data.styles || {};
        const fontSize = styles.fontSize || data.fontSize || 14;
        const lineHeight = styles.lineHeight || data.lineHeight || 1.4;
        const fontWeight = styles.fontWeight || data.fontWeight || 'normal';
        
        // Get color from styles.color, data.color, category color, or default to black
        let color = styles.color || data.color || '#000000';
        if (color && !color.startsWith('#')) {
            color = '#' + color.replace('#', '');
        }
        // If color is still not valid, try category color
        if (!color || color === '#undefined' || color === '#null') {
            if (data.category && data.category.color) {
                color = '#' + data.category.color.replace('#', '');
            } else {
                color = '#000000';
            }
        }
        
        // Get custom width from styles.width
        const customWidth = styles.width;
        const widthStyle = customWidth ? `width: ${customWidth}px;` : 'max-width: 300px;';
        
        const textDiv = document.createElement('div');
        textDiv.id = 'text-marker-' + index;
        textDiv.className = 'text-label-marker';
        textDiv.textContent = textContent;
        textDiv.style.cssText = `
            background-color: white;
            padding: 6px 10px;
            border-radius: 6px;
            font-size: ${fontSize}px;
            line-height: ${lineHeight};
            color: ${color};
            font-weight: ${fontWeight};
            text-align: center;
            word-wrap: break-word;
            ${widthStyle}
            box-shadow: 0 2px 6px rgba(0,0,0,0.2);
        `;
        
        // Use AdvancedMarkerElement for text marker
        const advancedMarker = new google.maps.marker.AdvancedMarkerElement({
            map: self.map,
            position: destination,
            content: textDiv,
            title: textContent,
            zIndex: 150
        });

        // Create Leg/Callout if offset exists
        let leg = null;
        if (data.offset_lat != null || data.offset_location) {
            const origin = location; // The original location passed in is the POI location
            
            const calloutStyles = data.callout_styles || { color: '#000000', weight: 2, opacity: 1 };
            
            leg = new google.maps.Polyline({
                path: [origin, destination],
                geodesic: false,
                strokeColor: calloutStyles.color,
                strokeOpacity: calloutStyles.opacity,
                strokeWeight: calloutStyles.weight,
                map: self.map,
                zIndex: 140
            });
        }
        
        // Store reference
        this.markers.push({
            index: index,
            poi: data,
            position: destination,
            visible: true,
            isVisible: function() { return this.visible; },
            show: function() { 
                this.advancedMarker.map = self.map;
                if (this.leg) this.leg.setMap(self.map);
                this.visible = true; 
            },
            hide: function() { 
                this.advancedMarker.map = null;
                if (this.leg) this.leg.setMap(null);
                this.visible = false; 
            },
            hideTooltip: function() {},
            showTooltip: function() {},
            textMarker: { content: textDiv }, // Maintain property structure for safety
            advancedMarker: advancedMarker,
            leg: leg
        });
    },
    renderDrawings: function() {
        var self = this;
        
        if (!bootstrap.drawings || !bootstrap.drawings.length) {
            return;
        }
        
        bootstrap.drawings.forEach(function(drawing) {
            if (!drawing.geometry || drawing.geometry.type !== 'Polygon') {
                return;
            }
            
            // Convert GeoJSON coordinates to Google Maps LatLng array
            const paths = drawing.geometry.coordinates[0].map(function(coord) {
                return new google.maps.LatLng(coord[1], coord[0]); // GeoJSON is [lng, lat], Google Maps is [lat, lng]
            });
            
            // Match Vue component terradraw styles
            // Defaults match TerraDrawPolygonMode styles from location-toolbar.vue
            const properties = drawing.properties || {};
            const fillColor = properties.fillColor || "#3b82f6";
            const fillOpacity = properties.fillOpacity !== undefined ? properties.fillOpacity : 0.4;
            // outlineColor uses properties.outlineColor OR properties.fillColor OR defaults to "#3b82f6"
            const outlineColor = properties.outlineColor || 
                                properties.fillColor || 
                                "#3b82f6";
            const outlineWidth = properties.outlineWidth !== undefined ? properties.outlineWidth : 2;
            
            // Create polygon with matching styles
            const polygonOptions = {
                paths: paths,
                map: self.map,
                strokeColor: outlineColor,
                strokeOpacity: 1.0, // TerraDraw uses full opacity for outlines
                strokeWeight: outlineWidth,
                fillColor: fillColor,
                fillOpacity: fillOpacity,
                clickable: false,
                zIndex: 1
            };
            
            const polygon = new google.maps.Polygon(polygonOptions);
            self.drawings.push(polygon);
            
            // Extend bounds to include polygon
            paths.forEach(function(path) {
                self.bounds.extend(path);
            });
        });
    }

}

document.addEventListener("DOMContentLoaded", (event) => {
    var mapCanvas = document.querySelector('#map_canvas');
    if (mapCanvas) {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    console.log('Loading google maps right now');
                    SharplaunchMap.loadScript();
                    observer.unobserve(entry.target);
                }
            });
        });

        const lazyLoadMapElements = document.querySelectorAll("#map_canvas");
        lazyLoadMapElements.forEach((element) => {
            observer.observe(element);
        });
    }
});

// Make it accessible on the global scope.
window.SharplaunchMap = SharplaunchMap;